import React, { useContext, useEffect, useState } from "react";
import { Form, Row } from "react-bootstrap";
import SmuUserIcon from "../../utils/smu-user-icon/SmuUserIcon";
import SmuModal from "../../utils/smu-modal/SmuModal";
import { COLOR_PRIMARY } from "../../constants/colors";
import SmuProfilePhotoEditor from "../../utils/smu-profile-photo-editor/SmuProfilePhotoEditor";
import loadingGif from "../../assets/images/loading.gif";
import { StoreContext } from "../../store/StoreContext";

const profiles = [
  {
    id: 1,
    title: "Admin",
  },
  {
    id: 2,
    title: "Usuario",
  },
];

const userTypes = [
  {
    id: "LDAP",
    title: "LDAP",
  },
  {
    id: "Local",
    title: "Local",
  },
];

const editorStyles = { height: 120, width: 120 };

const EditUser = ({ user, onHide, editUser }) => {
  const iconStyle = { height: 48, width: 48, borderRadius: 12 };

  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [userType, setUserType] = useState("LDAP");
  const [password, setPassword] = useState("");
  const [profileId, setProfileId] = useState(0);
  const [file, setFile] = useState("");

  useEffect(() => {
    if (!user) {
      setName("");
      setProfileId("");
      setPassword("");
      setUserType("LDAP");
      return;
    }

    setName(user?.name || user?.username);
    setPassword("");
    setUserType(user?.user_type || "LDAP");
    setProfileId((user.admin == true || user.admin == 'true') ? 1 : 2);
  }, [user]);

  const handleEdit = (event) => {
    event.preventDefault();
    if (!profileId) return;

    setLoading(true);
    const newUser = new FormData();

    newUser.append("username", user.email);
    newUser.append("name", name);
    newUser.append("status", 1);
    newUser.append("password", btoa(encodeURI(password)))
    newUser.append("user_type", userType);
    newUser.append("admin", profileId == 1);
    if (!!file) {
      newUser.append("avatar", file, file.name);
      newUser.append("is_public", true);
    }

    editUser(newUser).finally(() => {
      setLoading(false);
      setName("");
      setPassword("");
      setProfileId("");
      setFile("");
      setUserType("LDAP");
      onHide();
    });
  };

  return (
    <SmuModal
      show={Boolean(user)}
      onHide={onHide}
      contentTitle={
        <div className="d-flex align-items-center">
          <SmuUserIcon color={COLOR_PRIMARY} styles={iconStyle} />
          <div className="ms-3 fs-5 text-truncate">Perfil usuario</div>
        </div>
      }
    >
      <div className="my-5 d-flex">
        <SmuProfilePhotoEditor
          styles={editorStyles}
          avatar={user?.avatar}
          file={file}
          setFile={setFile}
        />
      </div>

      <div className="fs-6 mb-3">Dato del perfil</div>

      <Form
        id="edit-user"
        className="smu-form pb-5"
        onSubmit={(event) => handleEdit(event)}
      >
        <Row>
          <Form.Group className="col-6">
            <Form.Control
              type="text"
              className="text-dark"
              value={name}
              onChange={({ target }) => setName(target.value)}
            />
          </Form.Group>
          <Form.Group className="col-6">
            <Form.Select
              type="text"
              className="text-dark"
              value={profileId}
              onChange={({ target }) => setProfileId(Number(target.value))}
            >
              {profiles.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.title}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Row>
        <Row className="mt-4">
          <Form.Group className="col-6">
            <Form.Label htmlFor="passwd">Contraseña</Form.Label>
            <Form.Control
              type="password"
              id="passwd"
              disabled={userType==="LDAP"}
              className="text-dark"
              value={password}
              onChange={({ target }) => setPassword(target.value)}
            />
          </Form.Group>
          <Form.Group className="col-6">
          <Form.Label htmlFor="userType">Tipo de Usuario</Form.Label>
            <Form.Select
              type="text"
              id="userType"
              className="text-dark"
              value={userType}
              onChange={e => setUserType(e.target.value)}
            >
              {userTypes.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.title}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Row>
      </Form>

      <div className="d-flex mb-3 mt-5">
        {!loading ? (
          <button
            form="edit-user"
            type="submit"
            className="ms-auto smu-generic-button solid-btn py-1"
          >
            Guardar
          </button>
        ) : (
          <div className="ms-auto smu-generic-button solid-btn py-1 px-5">
            <img
              src={loadingGif}
              alt="Cargando"
              className="m-auto"
              width={20}
              height={20}
            />
          </div>
        )}
      </div>
    </SmuModal>
  );
};

export default EditUser;
